const userRules = {
  bio: {
    max: 100,
  },
  password: {
    max: 50,
    min: 8,
    specialCharacters: ["~","`","!","@","#","$","%","^","&","*","(",")","_","-","+","=","{","[","}","]","|",":",";",`"`,"'","<",",",">",".","?","/"]
    //Will eventually add more complex rules based on characters etc.
  },
  image: {
    max: 5e6
  }
}

export default userRules;